import React, { type ReactNode } from 'react'
import { cn } from '../utils'

export const Card: React.FC<{ 
    children: ReactNode; 
    className?: string;
    hover?: boolean;
} & React.HTMLAttributes<HTMLDivElement>> = ({ 
    children, 
    className, 
    hover = false,
    ...rest 
}) => (
    <div 
        className={cn(
            'bg-white dark:bg-white/5 border border-black/[.07] dark:border-white/[.07] rounded-xl overflow-hidden',
            hover && 'hover:border-black/10 dark:hover:border-white/10 transition-colors',
            className
        )} 
        {...rest}
    >
        {children}
    </div>
)